const DeliveryPlanning = {

    // FIELDS
    "vehicle": "Vehicle",
    "driver": "Driver",
    "description": "Description",
    "status": "Status",
    "dispatch_date": "Dispatch Date",
    "customer": "Customer",
    "items": "Items",
    "lat": "Latitude",
    "lng": "Longitude",
    "dispatch_address": "Dispatch Address",
    "repeated_customer": "Repeated Customer",
    "alredy_exist": "Customer Already Exist!!..",
    "item": "Item",
    "quantity": "Quantity",
    "unit": "Unit",
    "image": "Image",

    // PAGE HEADER
    "delivery_planning": "Delivery Planning",

    // ERROR
    "error_vehicle": "Select Vehicle",
    "error_driver": "Select Driver",
    "error_desc": "Enter Description",
    "error_status": "Select Status",
    "error_dispatch_date": "Choose Dispatch Date",
    "error_customer": "Select Customer",
    "error_lat": "Enter Latitude",
    "error_lng": "Enter Longitude",
    "error_dispatch_add": "Choose Dispatch Address",

    // TABLE HEADER
    "table_vehicle": 'VEHICLE',
    "table_description": "DESCRIPTION",
    "table_dispatch_date": "DISPATCH DATE",
    "table_status": "STATUS",
}

export default DeliveryPlanning;